import GenericDialog from "../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {Button, Typography} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import IconLeft from "@material-ui/icons/ChevronLeft";
import TipologiaApnTable from "./tipologia-apn-table/TipologiaApnTable";
import ServiziDetailsTable from "./servizi-details-table/ServiziDetailsTable";
import {filterInitialState, sortingOptions} from "./servizi-details-filter/ServiziDetailsFilterHelper";
import {updateObject} from "../../../../../../../../shared/utils/updateObject";
import ServiziDetailsFilter from "./servizi-details-filter/ServiziDetailsFilter";
import FilterHistory from "../../../../../../../../shared/components/filter-history/FilterHistory";
import {SortingAndButtonsAboveTable} from "../../../../../../../../shared/components/sorting-and-buttons-above-table/SortingAndButtonsAboveTable";
import {useDispatch} from "react-redux";
import * as actions from "../../../../../../../../store";
import PropTypes from "prop-types";
import {useParams} from "react-router-dom";
import ChangeApnDialog from "../../../../../sim/Dialogs/change-apn/ChangeApnDialog";

const ApnDialog = (props) => {
    const [selected, setSelected] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [page, setPage] = useState(0)
    const [sort, setSort] = useState(`${sortingOptions[0].value},desc`)
    const [filterHistory, setFilterHistory] = useState(filterInitialState)
    const [areAllSelected, setAreAllSelected] = useState(false)
    const [openCambioApn, setOpenCambioApn] = useState(false);
    const dispatch = useDispatch();
    const {digitalContractId} = useParams();

    useEffect(() => {
        dispatch(actions.getApnLists(digitalContractId))
        dispatch(actions.getApnSims(page, rowsPerPage, sort, filterHistory))
        dispatch(actions.getApnSimsFilterData())
        dispatch(actions.fetchSimTagsAutocomplete(''))
    }, [dispatch, digitalContractId, filterHistory, page, rowsPerPage, sort])

    const actionMenuItems = [
        {
            text: "Cambio APN",
            roles: "",
            disabled: selected.length > 1,
            handleClick: () => setOpenCambioApn(true)
        },
    ]

    const handleFilterSearch = (name, value) => {
        setPage(0);
        setFilterHistory(filterHistory => updateObject(filterHistory, {
            [name]: {
                ...filterHistory[name], value
            }
        }))
    }

    const handleFilterSelectsSearch = (value) => {
        setPage(0);
        setFilterHistory(prevFilterHistory => updateObject(prevFilterHistory, value))
    }

    const handleRemoveBadge = (key) => {
        setPage(0);
        setFilterHistory(filterHistory => updateObject(filterHistory, {
            [key]: {
                ...filterHistory[key],
                value: ""
            }
        }))
    }

    const handleResetFilter = () => {
        setPage(0);
        setFilterHistory(filterInitialState);
    }

    const handleTablePaginationChange = (page, rowsPerPage) => {
        setPage(page);
        setRowsPerPage(rowsPerPage);
    }

    const handleAnnullaClick = () => {
        setSelected([])
        setAreAllSelected(false)
    }

    const handleSortingChange = (value) => {
        setSort(value);
        setPage(0);
    }

    const mapToChangeApnSim = (selectedRow) => {
        return {
            iccId: selectedRow.iccid,
            msisdn: selectedRow.msisdn,
            currentApn: selectedRow.apnType
        }
    }

    const dialogContent = (
        <>
            <Button variant={"text"}
                    onClick={props.handleDialogClose}
                    startIcon={<IconLeft/>}
                    color={"primary"}>
                Indietro
            </Button>
            <TipologiaApnTable/>
            <Typography variant={"subtitle1"}>SIM associate agli APN</Typography>
            <ServiziDetailsFilter handleFilterSearch={handleFilterSearch}
                                  filter={filterHistory}
                                  handleSelectSearch={handleFilterSelectsSearch}/>
            <FilterHistory filter={filterHistory}
                           removeFilter={handleRemoveBadge}
                           resetFilter={handleResetFilter}/>

            <SortingAndButtonsAboveTable
                sortingValue={sort}
                changeSortingCriteria={handleSortingChange}
                sortingCriteria={sortingOptions}
                selectedData={selected.length}
                menuItems={actionMenuItems}
                handleAnnullaClick={handleAnnullaClick}/>
            <ServiziDetailsTable selected={selected}
                                 areAllSelected={areAllSelected}
                                 setAreAllSelected={setAreAllSelected}
                                 setSelected={setSelected}
                                 page={page}
                                 rowsPerPage={rowsPerPage}
                                 handlePaginationChange={handleTablePaginationChange}/>
            {openCambioApn ?
                <ChangeApnDialog open={openCambioApn}
                                 handleClose={() => setOpenCambioApn(false)}
                                 sim={mapToChangeApnSim(selected[0])}
                                 loadSchedaTecnica={false}/>
                : null}
        </>
    )

    return (
        <GenericDialog dialogWidth={"lg"}
                       open={props.open}
                       handleDialogClose={props.handleDialogClose}
                       handleDialogCloseButton={props.handleDialogClose}
                       dialogContent={dialogContent}>
            <Typography variant={"h5"}>APN</Typography>
        </GenericDialog>
    )
}

ApnDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
}

export default ApnDialog;